import { useState, useEffect } from 'react';

const BREAKPOINTS = { sm: 576, md: 768, lg: 992, xl: 1200 } as const;

export function useBreakpoint() {
  const [width, setWidth] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth : 1024
  );

  useEffect(() => {
    const handler = () => setWidth(window.innerWidth);
    const mq = window.matchMedia(`(max-width: ${BREAKPOINTS.md - 1}px)`);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return {
    width,
    isMobile: width < BREAKPOINTS.md,
    isTablet: width >= BREAKPOINTS.md && width < BREAKPOINTS.lg,
    isDesktop: width >= BREAKPOINTS.lg
  };
}
